module.exports = __webpack_public_path__ + "img/major-image-default.30c00b09.png";